import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const STORAGE_KEY = 'tm-cookie-notice';

export default function CookieNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setShow(true);
    } catch {
      /* localStorage unavailable — don't show the notice */
    }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="cookie-notice"
      className="fixed bottom-3 left-3 right-[4.5rem] sm:bottom-4 sm:left-4 sm:right-auto sm:max-w-md z-[60] bg-slate-900 text-white border border-white/10 rounded-2xl shadow-2xl p-5"
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 text-xs sm:text-sm leading-relaxed">
          <p className="font-display font-bold uppercase tracking-tight text-sm mb-1">Cookies &amp; data</p>
          <p>
            TradesMate only uses <strong>strictly-necessary cookies</strong> (to keep you signed in). No ad-tech trackers.{' '}
            <Link to="/legal/cookies" className="underline hover:text-brand">Cookie policy</Link>
            {' · '}
            <Link to="/legal/privacy" className="underline hover:text-brand">Privacy</Link>
          </p>
        </div>
        <button
          data-testid="cookie-notice-dismiss"
          onClick={dismiss}
          aria-label="Dismiss"
          className="text-slate-300 hover:text-white shrink-0 p-1 -m-1"
        >
          <X size={16}/>
        </button>
      </div>
    </div>
  );
}
